import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import useElement from "backend/hooks/elements/useElement";
import React from "react";

const Perspective = () => {
  const ctx = useAppContext();
  const link = useLink();
  const { data } = useElement(ctx.elementId);

  React.useEffect(() => {
    link({ meaId: data?.parent_element_id });
  }, [data]);
  if (!data) return null;

  return <div />;
};

export default Perspective;
